
import dataservice from "../../core/services/dataservice";
import _ from "lodash";
import { onValue, child, set } from "firebase/database";
import dayjs from "dayjs";
import { FIRESTORE_COLLECTIONS } from "~~/interface/FirestoreCollections";
import { query, where, orderBy, limit, onSnapshot, QuerySnapshot, updateDoc, serverTimestamp, Timestamp } from "firebase/firestore";
import { RunMode } from "~~/interface/Pos";


// qrcode_orders เป็นแค่กล่องขาเข้า ไม่ใช่ที่เก็บข้อมูลจริง
// ของจริงถูกย้ายเข้า jobchain ตั้งแต่ตอน jobsStore.add(data, true) แล้ว ลบทิ้งได้ไม่กระทบใบเสร็จ
// ที่ยังเก็บไว้ 7 วันเพราะเผื่อไว้ย้อนดูว่าออเดอร์จากเมนู QR เข้ามาจริงไหม ตอนลูกค้าทักมาทีหลัง
//
// แยกเป็นค่าคงที่เพื่อให้ grep เจอ และให้เลขตรงกับฝั่งที่สร้างเอกสาร (nuxt3-mobile-order)
// ซึ่งต้องเซ็ต expireAt ชื่อเดียวกันนี้ตอน create ไม่งั้นออเดอร์ที่ร้านไม่เคยกดรับจะค้าง pending ตลอดกาล
const QR_ORDER_TTL_DAYS = 7


export const useQrCodeOrdersStore = defineStore("qrcode_orders", {
    state: () => {
        return {
            list: {} as any,
            itemsHolderUuid: {} as any
        };
    },

    actions: {
        async init() {

            setTimeout(() => {
                let runMode = useRunningMode().getMode()

                if (runMode == RunMode.MAIN_CASHIER) {
                    this.fetchFirestore()
                }
            }, 4000);
        },

        async fetchFirestore() {

            const toastStore = useToastStore()
            const jobsStore = useJobsStore()


            let self = this

            let firestoreInstance = useFirebaseFirestore()
            let ordersRef = firestoreInstance.subCollectionRef(FIRESTORE_COLLECTIONS.QR_CODE_ORDERS)
            const q = query(ordersRef, where("status", "==", "pending"), orderBy("timestamp"), limit(1));
            const unsub = onSnapshot(q, async (querySnapshot: QuerySnapshot) => {
                for (const doc of querySnapshot.docs) {
                    const data = doc.data()
                    const ordersID_Ref = firestoreInstance.subCollectionDocIdRef(FIRESTORE_COLLECTIONS.QR_CODE_ORDERS, doc.id)

                    this.list[doc.id] = data

                    // Check if any item already exists
                    const isExist = _.some(data.items, (item: any) => this.itemsHolderUuid[item.uuid])

                    if (!isExist) {
                        jobsStore.add(data, true)
                        toastStore.showOrder(data)

                        // Mark uuid as received locally
                        _.forEach(data.items, (item: any) => {
                            this.itemsHolderUuid[item.uuid] = doc.id
                        })
                    }

                    // Always mark as received in Firestore
                    await updateDoc(ordersID_Ref, {
                        status: "received",
                        receivedAt: serverTimestamp(),

                        // TTL policy ของ Firestore มองเห็นเฉพาะ field ที่เป็น Timestamp เท่านั้น
                        // ถ้าเผลอส่งเป็น string หรือ number (เช่น .toISOString() หรือ .valueOf())
                        // policy จะข้ามเอกสารนี้เงียบ ๆ ไม่มี error ไม่มี log อาการคือดูเหมือนทำงานได้ปกติ
                        // แต่ไม่มีอะไรถูกลบสักที กว่าจะรู้ก็ตอนบิลค่า storage มา
                        //
                        // และห้ามใช้ serverTimestamp() ตรงนี้เด็ดขาด มันเป็น sentinel ที่ยังไม่มีค่า
                        // TTL ต้องการวันหมดอายุที่เป็นค่าจริงอยู่ในเอกสารแล้ว เลยต้องคำนวณฝั่ง client ส่งไปตรง ๆ
                        //
                        // ใช้ dayjs() เฉย ๆ ไม่ต้องผ่าน useServerTime() เพราะระยะ 7 วัน
                        // กว้างกว่านาฬิกาเครื่องเพี้ยนหลายขุม ต่อให้คลาดไปเป็นชั่วโมงก็ไม่มีผล
                        expireAt: Timestamp.fromDate(dayjs().add(QR_ORDER_TTL_DAYS, "day").toDate()),
                    })
                }
            });
        },

        insert(table) {


        },

        remove(qrcodeId) {

        }

    },
});
